import React from "react";
import { Shield, Activity, Heart, UserCheck } from "lucide-react";

const PILLARS = [
  {
    n: "01",
    title: "Preventive Presence",
    icon: Shield,
    body:
      "Consistent, controlled canine-handler presence shifts the baseline of a room. Tension drops before it has a chance to compound.",
  },
  {
    n: "02",
    title: "Regulated Interaction",
    icon: Activity,
    body:
      "Engagement is structured, not spontaneous — pacing, duration and proximity are governed by a defined protocol, never by demand.",
  },
  {
    n: "03",
    title: "Welfare Supremacy",
    icon: Heart,
    body:
      "The dog's well-being is not negotiable. It is the operational substrate that makes the entire model reliable, ethical, and repeatable.",
  },
  {
    n: "04",
    title: "Handler Authority",
    icon: UserCheck,
    body:
      "Handlers possess absolute halt-authority. Safety, dignity, and protocol fidelity always supersede convenience or institutional pressure.",
  },
];

export default function DoctrinePillars() {
  return (
    <section
      data-testid="doctrine-pillars"
      className="bg-slate-50 border-y border-slate-200"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-4">
            <div className="flex items-center gap-3">
              <span className="brand-rule" />
              <span className="overline">The Doctrine</span>
            </div>
            <h2 className="mt-6 font-display font-black text-3xl md:text-5xl tracking-tight leading-[1.05] text-slate-900">
              Four pillars,
              <br />
              one operating model.
            </h2>
            <p className="mt-6 text-slate-600 max-w-md leading-relaxed">
              Every deployment is governed by the same codified architecture. Consistency
              is what makes a stabilization model scalable — and trustable.
            </p>
          </div>

          <div className="col-span-12 md:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-12">
            {PILLARS.map((p) => {
              const Icon = p.icon;
              return (
                <div
                  key={p.n}
                  data-testid={`pillar-${p.n}`}
                  className="group border-l-2 border-slate-200 hover:border-amber-600 pl-6 transition-colors duration-300"
                >
                  <div className="flex items-center justify-between">
                    <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-amber-600">
                      {p.n}
                    </span>
                    <Icon
                      size={20}
                      className="text-slate-400 group-hover:text-amber-600 transition-colors"
                      strokeWidth={1.5}
                    />
                  </div>
                  <h3 className="mt-4 font-display font-bold text-xl md:text-2xl text-slate-900">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-slate-600 leading-relaxed text-[15px]">
                    {p.body}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
